import React, { FC, useEffect, useState } from "react";
import classes from "./MediaImages.module.css";
import { motion } from "framer-motion";

type MediaImagesProps = {
  mediaDetails: any;
  windowWidth: number;
};

const MediaImages: FC<MediaImagesProps> = ({ mediaDetails, windowWidth }) => {
  const [leftConstraint, setLeftConstraint] = useState<number>(0);

  useEffect(() => {
    const updateConstraints = () => {
      if (window.innerWidth <= 800) {
        setLeftConstraint(
          10 +
            mediaDetails?.result?.images?.backdrops?.length * 150 +
            mediaDetails?.result?.images?.backdrops?.length * 10 +
            mediaDetails?.result?.images?.backdrops?.length * 1 -
            windowWidth
        );
      } else {
        setLeftConstraint(
          window.innerWidth * 0.05 +
            mediaDetails?.result?.images?.backdrops?.length * 150 +
            mediaDetails?.result?.images?.backdrops?.length * 10 +
            mediaDetails?.result?.images?.backdrops?.length * 1 -
            windowWidth
        );
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, [windowWidth,mediaDetails]);

  return (
    <div className={classes.carousel_container}>
      <motion.div
        className={classes.section_image_cards}
        style={{
          gridTemplateColumns: `repeat(${mediaDetails?.result?.images?.backdrops?.length}, 150px)`,
        }}
        drag="x"
        dragConstraints={{
          top: 0,
          left: -leftConstraint,
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {mediaDetails?.result?.images?.backdrops?.map(
          (dataItem: any, idx: number) => (
            <div className={classes.image_card}>
              <img
                src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                  "<replace_media_id>",
                  dataItem?.file_path
                )}`}
                alt="movie photos"
                className={classes.image}
              />
            </div>
          )
        )}
      </motion.div>
    </div>
  );
};

export default MediaImages;
